import(/* webpackMode: "eager" */ "/home/rajat/Downloads/HR Shakti/frontend/src/app/(app)/loading.tsx");
